import React, {Component} from "react";
import PropTypes from "prop-types";
import {Redirect} from 'react-router';
import {NavLink, Link} from 'react-router-dom';
import Loader from '../Loader'
import api from "../../api/Api";
import "react-table/react-table.css";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";
import TagsInput from 'react-tagsinput'

// core components
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardText from "components/Card/CardText.jsx";
import Icon from '@material-ui/core/Icon';
import Assignment from "@material-ui/icons/Assignment";
import SearchComponent from "components/Search/AutoCompletePatient.jsx";
import LocalHospital from "@material-ui/icons/LocalHospital";
import Button from "components/CustomButtons/Button.jsx";


import GridContainer from "components/Grid/GridContainer.jsx";

import {mappingUI, dashboardRouter, getDateConverter} from '../../util/globalHelper';
import Permissions from '../../util/globalPermissions';
const styles = {
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontSize: "65%",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    AutoCompleteClass: {
        width: '100%',
        padding: 0,
        margin: '20px 0',
        height: 0,
        position: 'inherit'
    }
};
class OneTest extends Component {
    constructor() {
        super();
        this.state = {
            data: null,
            clinicsData: null,
            simpleSelect: "",
            doctorsData: null,
            notFound: null,
            start_date: "",
            end_date: "",
            clinic_id: "",
            doctor_id: "",
            patientId: "",
            type: "",
            selectPic: 0,
            deleted: false
        };
        this.onChangeSelect = this.onChangeSelect.bind(this)
    }

    handleChangeStartDate(event) {
        this.setState({start_date: event.format('YYYY-MM-DD')});
    }

    handleChangeEndDate(event) {
        this.setState({end_date: event.format('YYYY-MM-DD')});
    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    CallReadApi = (id) => {
        api.getTests({
            // clinic_master_id: masterid,
            // clinic_id: clinicid,
            _id: id
        })
            .then(json => {
                this.setState({data: json.data.data});
            }).catch(error => {
            this.setState({notFound: error})
        });
    }

    componentDidMount() {
        this.CallReadApi(this.props.id.match.params.id);
    }


    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    render() {
        const {data, clinicsData, doctorsData} = this.state;
        const {classes} = this.props;
        if (this.state.data !== null && this.state.data !== undefined) {
            return (
                <div>
                    {this.state.alert}
                    <Grid container>
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <GridContainer>
                                            <GridItem>
                                                <Assignment/>
                                            </GridItem>

                                            <GridItem>
                                                <h4 className={classes.cardTitleWhite}>Test</h4>
                                            </GridItem>
                                        </GridContainer>
                                    </CardText>
                                </CardHeader>
                                <CardBody>
                                    <GridContainer className="leftAlight">
                                        <GridItem md={12} sm={12} xs={12}>
                                            <GridItem xs={12}>

                                                <h3><b>{data.name ? data.name : "No Title"}</b></h3>
                                                <br/>
                                                {data.services && data.services >0 ?  
                                                <TagsInput size="lg" tagProps={{className: "react-tagsinput-tag info"}}
                                                value={data.services.filter(function (value, index, arr) {
                                                    return value !== "" && value !== null
                                                }).map(item => {
                                                    return <b>{item.name}<br/></b>
                                                })} disabled
                                                onChange={this.handleChange} inputProps={{placeholder: ""}}/>  : null }
                                            </GridItem>
                                        </GridItem>
                                    </GridContainer>
                                    <GridContainer className="leftAlight">

                                        <GridItem md={8} sm={8} xs={12}>

                                            <GridItem xs={12}>
                                                <h4>{data.master_test_id.description ? data.master_test_id.description[0] === "<" ?
                                                    <div
                                                        dangerouslySetInnerHTML={{__html: data.master_test_id.description}}/> : data.master_test_id.description : null}
                                                </h4>
                                                <br />
                                            </GridItem>

                                            <GridItem>
                                            <GridContainer>
                                            
                                            <GridItem xs={12} sm={6}>
                                                <h4>
                                                    <b>{data && data.total ? data.total : null}</b>
                                                </h4>
                                                <h5>Price</h5>
                                            </GridItem>
                                            {data && data.discounted_price ? <GridItem xs={12} sm={6}>
                                                <h4>
                                                    <b>{data.discounted_price}</b>
                                                </h4>
                                                <h5>Discounted Price</h5>
                                            </GridItem>  : null}
                                            <GridItem xs={12} sm={6}>
                                                <h4><b>{data.clinic_id ? data.clinic_id.name : "NA"}</b></h4>
                                                <h5>Clinic</h5>
                                            </GridItem>
                                            
                                            </GridContainer>
                                            </GridItem>
                                            <br />
                                        </GridItem>

                                        <GridItem md={4} sm={4} xs={12}>
                                            <GridItem xs={12}>
                                                {/*<b>{data && data.services ? "Services: " : null}</b>*/}
                                                {/*<br/>*/}
                                                {/*{data.services.filter(function (value, index, arr) {*/}
                                                {/*return value !== "" && value !== null*/}
                                                {/*}).map(item => {*/}
                                                {/*return <b>{item.name}<br/></b>*/}
                                                {/*})}*/}
                                            </GridItem>
                                            <NavLink
                                                to={dashboardRouter(`/tests/update/${data._id}`)}>
                                                <Button block size="md" color="warning">
                                                    <Icon>edit</Icon>
                                                    <span style={{paddingLeft: 10}}>Update</span>
                                                </Button>
                                            </NavLink>
                                        </GridItem>
                                    </GridContainer>
                                </CardBody>
                            </Card>
                        </GridItem>
                    </Grid>
                </div>
            );
        }
        else if (this.state.notFound !== null) {
            return <h2 className="text-center">Data Not Found</h2>
        }
        else return (
                <div>
                    <Loader/>
                </div>
            )
    }
}
export default withStyles(styles)(OneTest);




// WEBPACK FOOTER //
// ./src/components/Tests/oneTest.jsx